import { Component, OnInit } from '@angular/core';
import { Field } from '@ngx-formly/core';
import * as _ from 'lodash';

@Component({
  selector: 'tr-input-with-addon',
  templateUrl: './input-with-addon.component.html',
  // styleUrls: ['./input-with-addon.component.scss']
})
export class InputWithAddonComponent extends Field {
  hasDanger: boolean = false;

  get subType() {
    return _.has(this.to, 'type') ? this.to.type : 'text';
  }

  isDisabled() {
    return _.includes(this.field.className, 'disabled');
  }
}



// WEBPACK FOOTER //
// ./src/app/stage/components/input-with-addon/input-with-addon.component.ts